module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'User Management',
          to: {
            path: '/user-management'
          }
        },
        {
          text: 'Informasi User'
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Ubah User Info")]), _vm._v(" "), _c('div', [_c('v-card', {
    staticStyle: {}
  }, [_c('v-tabs', [_c('v-tab', [_vm._v("Ubah User Info")]), _vm._v(" "), (!_vm.isActive) ? _c('v-tab', [_vm._v("Aktivasi User")]) : _vm._e(), _vm._v(" "), _c('v-tab', [_vm._v("Jadwal Kelas")]), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    staticClass: "d-flex mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl px-2",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": "1",
      "src": _vm.$store.state.usman
        .picture
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "border-left": "1px solid #f0f0f0"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                No Siswa\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "user-student-number",
      "placeholder": "No. Siswa",
      "outlined": ""
    },
    on: {
      "keypress": function($event) {
        /\d/.test(
            String.fromCharCode(
              $event.keyCode
            )
          ) ||
          $event.keyCode == 45 ?
          true :
          $event.preventDefault()
      }
    },
    model: {
      value: (
        _vm.data.student_number
      ),
      callback: function($$v) {
        _vm.$set(_vm.data, "student_number", $$v)
      },
      expression: "\n                                                    data.student_number\n                                                "
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Nama Siswa *\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "user-name",
      "placeholder": "Nama Siswa",
      "outlined": ""
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Email\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "user-email",
      "disabled": "",
      "placeholder": "Email",
      "outlined": ""
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                No.Telpon\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "user-phone-number",
      "disabled": "",
      "placeholder": "No. Telpon",
      "dense": _vm.$vuetify.breakpoint
        .smAndDown,
      "outlined": ""
    },
    model: {
      value: (_vm.data.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.data, "phone_number", $$v)
      },
      expression: "data.phone_number"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Sekolah\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "user-school",
      "placeholder": "Sekolah",
      "outlined": ""
    },
    model: {
      value: (_vm.data.school),
      callback: function($$v) {
        _vm.$set(_vm.data, "school", $$v)
      },
      expression: "data.school"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Kelas\n                                            ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "user-grade",
      "items": [{
          text: '1 (SD)',
          value: 1,
        },
        {
          text: '2 (SD)',
          value: 2,
        },
        {
          text: '3 (SD)',
          value: 3,
        },
        {
          text: '4 (SD)',
          value: 4,
        },
        {
          text: '5 (SD)',
          value: 5,
        },
        {
          text: '6 (SD)',
          value: 6,
        },
        {
          text: '7 (SMP)',
          value: 7,
        },
        {
          text: '8 (SMP)',
          value: 8,
        },
        {
          text: '9 (SMP)',
          value: 9,
        },
        {
          text: '10 (SMA)',
          value: 10,
        },
        {
          text: '11 (SMA)',
          value: 11,
        },
        {
          text: '12 (SMA)',
          value: 12,
        } ],
      "outlined": ""
    },
    model: {
      value: (_vm.data.grade),
      callback: function($$v) {
        _vm.$set(_vm.data, "grade", $$v)
      },
      expression: "data.grade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Status\n                                            ")]), _vm._v(" "), _c('div', [(
    _vm.data.deactivate == 0
  ) ? _c('v-btn', {
    attrs: {
      "disabled": "",
      "depressed": "",
      "color": "fade"
    }
  }, [_c('span', {
    staticClass: "dark--text"
  }, [_vm._v("\n                                                        Berakhir pada\n                                                        " + _vm._s(_vm.$moment(
    _vm.data.expired_at
  ).format(
    "MMM DD, YYYY"
  )) + "\n                                                    ")])]) : _vm._e(), _vm._v(" "), (
    _vm.data.deactivate == 0
  ) ? _c('v-btn', {
    attrs: {
      "id": "user-deactivate-btn",
      "block": false,
      "fab": "",
      "depressed": "",
      "min-width": "21px",
      "width": "21px",
      "min-height": "21px",
      "height": "21px",
      "color": "redLight"
    },
    on: {
      "click": function($event) {
        return _vm.deactivate()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "white"
    }
  }, [_vm._v("mdi-close")])], 1) : _c('v-btn', {
    attrs: {
      "block": false,
      "disabled": ""
    }
  }, [_vm._v("\n                                                    Berakhir\n                                                    " + _vm._s(_vm.data.expired_at) + "\n                                                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                User Scope *\n                                            ")]), _vm._v(" "), _c('v-row', [_c('v-col', _vm._l((_vm.data.app_scope), function(fitur, i) {
    return _c('v-select', {
      key: i,
      staticClass: "select_scope",
      attrs: {
        "items": _vm.scopes,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "placeholder": "-- Pilih user scope --",
        "outlined": ""
      },
      model: {
        value: (
          _vm.data.app_scope[
            i
          ]
        ),
        callback: function($$v) {
          _vm.$set(_vm.data.app_scope,
            i, $$v)
        },
        expression: "\n                                                            data.app_scope[\n                                                                i\n                                                            ]\n                                                        "
      }
    })
  }), 1), _vm._v(" "), _c('v-col', _vm._l((_vm.user_scope_expired_menu), function(fitur, i) {
    return _c('v-menu', {
      key: i,
      ref: "menu",
      refInFor: true,
      staticClass: "date_picker",
      attrs: {
        "close-on-content-click": false,
        "transition": "slide-y-reverse-transition",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "readonly": "",
                "outlined": ""
              },
              model: {
                value: (
                  _vm.user_scope_expired_menu[
                    i
                  ].value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.user_scope_expired_menu[
                    i
                  ], "value", $$v)
                },
                expression: "\n                                                                    user_scope_expired_menu[\n                                                                        i\n                                                                    ].value\n                                                                "
              }
            }, 'v-text-field',
            attrs, false), on))]
        }
      }], null, true),
      model: {
        value: (
          _vm.user_scope_expired_menu[
            i
          ].option
        ),
        callback: function($$v) {
          _vm.$set(_vm.user_scope_expired_menu[
            i
          ], "option", $$v)
        },
        expression: "\n                                                            user_scope_expired_menu[\n                                                                i\n                                                            ].option\n                                                        "
      }
    }, [_vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "scrollable": ""
      },
      on: {
        "change": function($event) {
          _vm.user_scope_expired_menu[
              i
            ].option =
            false
        }
      },
      model: {
        value: (
          _vm.user_scope_expired_menu[
            i
          ].value
        ),
        callback: function($$v) {
          _vm.$set(_vm.user_scope_expired_menu[
            i
          ], "value", $$v)
        },
        expression: "\n                                                                user_scope_expired_menu[\n                                                                    i\n                                                                ].value\n                                                            "
      }
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-btn', {
    staticClass: "font-weight-bold dark--text",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.addScope()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                                            Tambah Scope Baru\n                                        ")], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-2",
    attrs: {
      "id": "user-cancel-btn",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "id": "user-save-btn",
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isActive) ? _c('v-tab-item', [_c('v-card', {
    staticClass: "mt-5"
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "ml-4"
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "non_nf_student",
      "label": "Siswa Non NF",
      "value": "non_nf_student",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "nf_student",
      "label": "Siswa NF",
      "value": "nf_student",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                        Email SIP\n                                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "user-name",
      "placeholder": "Email SIP",
      "outlined": ""
    },
    model: {
      value: (_vm.activation.email),
      callback: function($$v) {
        _vm.$set(_vm.activation, "email", $$v)
      },
      expression: "activation.email"
    }
  })], 1)], 1), _vm._v(" "), (_vm.type === 'nf_student') ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                        Nomor Induk\n                                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "user-name",
      "placeholder": "Nomor Induk NF, 123-45-67890",
      "outlined": ""
    },
    model: {
      value: (_vm.activation.nomorIndukNF),
      callback: function($$v) {
        _vm.$set(_vm.activation, "nomorIndukNF", $$v)
      },
      expression: "activation.nomorIndukNF"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'non_nf_student') ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                        Paket\n                                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "user-grade",
      "placeholder": "Pilih paket",
      "items": _vm.packageList,
      "item-text": "name",
      "item-value": "id",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDetailPackage(
          _vm.activation.package_id
        )
      }
    },
    model: {
      value: (_vm.activation.package_id),
      callback: function($$v) {
        _vm.$set(_vm.activation, "package_id", $$v)
      },
      expression: "activation.package_id"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-2",
    attrs: {
      "id": "user-cancel-btn",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), (_vm.type === 'non_nf_student') ? _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "id": "user-save-btn",
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.activateUserGeneral()
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e(), _vm._v(" "), (_vm.type === 'nf_student') ? _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "id": "user-save-btn",
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.activateUser()
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    staticClass: "mt-5"
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                        Jadwal Kelas\n                                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "user-grade",
      "placeholder": "Pilih Jadwal",
      "items": _vm.package_groups,
      "item-text": "name",
      "item-value": "name",
      "outlined": ""
    },
    model: {
      value: (_vm.group_id),
      callback: function($$v) {
        _vm.group_id = $$v
      },
      expression: "group_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-2",
    attrs: {
      "id": "user-cancel-btn",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "id": "user-save-btn",
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.editSchedule()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dc9256","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/usman/components/UserManagementForm.vue
// module id = 2155
// module chunks = 1